var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage');

function Model(params) {
  var self = this;

  if (params.addEmployeeEndpoint === undefined)
    throw 'addEmployeeEndpoint not set';

  if (typeof params.addNewEmployee !== 'function')
    throw 'addNewEmployee function must be defined';

  if (typeof params.closeDialog !== 'function')
    throw 'closeDialog function must be defined';

  self.closeDialog = params.closeDialog;
  self.firstName = ko.observable();
  self.lastName = ko.observable();
  self.email = ko.observable();
  self.phone = ko.observable();

  self.isAddingEmployee = ko.observable(false);

  var validateField = function (field) {
    return field !== undefined && field !== '';
  };

  var getAgencyId = function () {
    var agency = cart.getCart().agency;
    if (agency !== undefined) return agency.AktorId;

    throw 'Cannot add new employee to unknown agency';
  };

  self.errorText = ko.observable('');
  self.showErrorMessage = ko.computed(function () {
    return self.errorText() !== '';
  });

  self.hideErrorMessage = function () {
    self.errorText('');
  };

  self.addEmployee = function () {
    var email = self.email();
    var phone = self.phone();
    var firstName = self.firstName();
    var lastName = self.lastName();

    var agencyId = getAgencyId();

    if (
      validateField(email) &&
      validateField(phone) &&
      validateField(firstName) &&
      validateField(lastName)
    ) {
      self.isAddingEmployee(true);

      if (/.json$/.test(params.addEmployeeEndpoint)) {
        params.addNewEmployee({ Name: firstName + ' ' + lastName });
        self.isAddingEmployee(false);
      } else {
        $.post(params.addEmployeeEndpoint, {
          Email: email,
          Phone: phone,
          FirstName: firstName,
          LastName: lastName,
          AgencyAktorId: agencyId
        })
          .done(function (employee) {
            params.addNewEmployee(employee);
            self.isAddingEmployee(false);
          })
          .fail(function (err) {
            self.errorText(err.responseText);
            self.isAddingEmployee(false);
          });
      }
    } else {
      self.errorText(window.language.errorCreateEmployee);
    }
  };
}

module.exports = Model;
